<br>

<div style="width: auto; overflow: auto">
    <app-common-list-table
        [request]="getRequest"
        [cols]="cols"
        [filtering]="filter"
        actionButtonText="Añadir transacción" 
        (actionButtonClick)="add()"
        [globalVisualTransform]="globalVisualTransform"
        [globalConditionalStyle]="globalConditionalStyle">
        <ng-template #header let-data>
            <div style="width: 100%; margin-right: 15px" class="d-flex justify-content-center align-items-center" *ngIf="appName !== 'ctl' ">
                <div style="margin-left: 10px; margin-right: 10px">
                    <div style="font-size: 0.7em" class="btn-group">
                        <button type="button" class="btn btn-info" style="padding: 5px; font-size: .8rem; background-color: #16A2B7; color: white; width: 8rem;"
                        (click)="show('generateFile', modelGenFields)"
                        >Generar archivo</button>
                    </div>
                </div>
            </div>
            <div style="width: 100%; margin-right: 15px" class="d-flex justify-content-center align-items-center" *ngIf="appName === 'ctl' && (user.id === '2' || user.id === '1' ) ">
                <div style="margin-left: 10px; margin-right: 10px">
                    <div style="font-size: 0.7em" class="btn-group">
                        <button type="button" class="btn btn-info" style="padding: 5px; font-size: .8rem; background-color: #16A2B7; color: white; width: 8rem;"
                        (click)="show('generateFile', modelGenFields)"
                        >Generar archivo</button>
                    </div>
                </div>
            </div>
        </ng-template>
        <ng-template #thEnd>
          
            <th>
                <p class="d-flex justify-content-center" style="margin-bottom: 0">Acciones</p>
            </th>
         
           
        </ng-template>

        <ng-template #tdEnd let-data let-isFirstRow="isFirstRow">
            <td>
                <app-action-buttons
                    [tourAnchorId]="isFirstRow ? 'farmerTour.rowActions' : ''"
                    [showDuplicate]="true"
                    (duplicateRowButtonEvent)="duplicate(data.data)"
                    (editRowButtonEvent)="edit(data.data)"
                    (deleteRowButtonEvent)="show('delete', data.data)"
                    (showRowButtonEvent)="show('info', data.data)">
                </app-action-buttons>
            </td>
        
         
        </ng-template>
    </app-common-list-table>
</div>


<app-modals
    [view]="this"
    [form]="form?.formFields"
    [serverUrl]="serverUrl"
    [previousData]="model"
    [recordHasAssociatedData]="true"
    [getRequest]="getRequest"
    [deleteRequest]="deleteRequest"
    (generateFileClosed)="emptyDates()">

    <ng-template #generateFileContent>
        <div style="min-height: 40vw !important;">
            <app-reactive-form-builder
                [form]="generateForm.formFields"
                [previousData]="modelGenFields"
                [showActionsButtons]="false"
                (formChanges)="formChanges($event[0], $event[1])">
            </app-reactive-form-builder>

            <br>
            <div class="d-flex justify-content-center">
                <button class="btn btn-dark mx-2" (click)="hide('generateFile')">Cerrar</button>

                <a class="d-flex justify-content-center mx-2">
                    <button *ngIf="canGenFile" class="btn btn-primary" (click)="generarArchivo()">Generar</button>
                </a>
            </div>
            <br>
        </div>
    </ng-template>
</app-modals>
